import { render, staticRenderFns } from "./InsightsPage.vue?vue&type=template&id=9be0214a&scoped=true"
import script from "./InsightsPage.vue?vue&type=script&lang=js"
export * from "./InsightsPage.vue?vue&type=script&lang=js"
import style0 from "./InsightsPage.vue?vue&type=style&index=0&id=9be0214a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be0214a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9be0214a')) {
      api.createRecord('9be0214a', component.options)
    } else {
      api.reload('9be0214a', component.options)
    }
    module.hot.accept("./InsightsPage.vue?vue&type=template&id=9be0214a&scoped=true", function () {
      api.rerender('9be0214a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/InsightsPage.vue"
export default component.exports